import "core-js/modules/es.object.freeze.js";
import { renderTrustedMarkdown } from '~/functions/markdown';
import { TemplateEngineContext } from '~/types/types';
import { canEditImpact, useRealUserIsIxAdmin } from '~/functions/impact-locking';
var temp = Object.freeze({
  impactGoalId: undefined,
  id: undefined,
  conceptId: null,
  stakeholder: '',
  isPositive: true
});
var CUSTOM_DEFINE_SECTION_ID = 920042;
export default defineComponent({
  props: {
    impact: {
      type: Object,
      default: function _default() {
        return Object.assign({}, temp);
      }
    },
    impactGoal: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var showIxMethodology = ref(false);
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var impactEditable = computed(function () {
      return canEditImpact(props.impact, realUserIsIxAdmin.value);
    });
    return {
      ventureId: ventureId,
      showIxMethodology: showIxMethodology,
      renderTrustedMarkdown: renderTrustedMarkdown,
      impactEditable: impactEditable,
      TemplateEngineContext: TemplateEngineContext,
      CUSTOM_DEFINE_SECTION_ID: CUSTOM_DEFINE_SECTION_ID
    };
  },
  data: function data() {
    return {
      country: [],
      valid: false,
      requiredRule: [function (v) {
        return !!v || 'This field is required';
      }]
    };
  }
});